import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getAllAddressUserSuccess,
  getAllAddressUserFailed,
  GET_ALL_ADDRESS_USER_START,
} from '../../actions/accountProfile'
import { api } from '~/services/api'

/**
 * get list add address api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListAddressUser = (props) => {
  var uri = `/tes-users`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListAddressUser(action) {
  try {
    const response = yield call(getListAddressUser, action?.payload)
    yield put(getAllAddressUserSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getAllAddressUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list add address
 */
export default function* watchGetAddAddressUser() {
  yield takeLatest(GET_ALL_ADDRESS_USER_START, doGetListAddressUser)
}
